import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';
import {
  RrhhTeamDetail,
  RrhhTeamsList,
  TeamMember,
} from '@base/src/app/models/rrhh.model';
import * as moment from 'moment';
import { AgentModel } from 'src/app/models/agent.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { QRInput } from 'src/app/models/qr-input.model';
import { RrhhAgentService } from 'src/app/services/rrhh/rrhh-agents.service';
import { RrhhTeamsListService } from 'src/app/services/rrhh/rrhh-teams-list.service';
import { RrhhVerificationsService } from 'src/app/services/rrhh/rrhh-verifications.service';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-rrhh-data-form',
  templateUrl: './rrhh-data-form.component.html',
  styleUrls: ['./rrhh-data-form.component.scss'],
})
export class RrhhDataFormComponent implements OnInit {
  @Input() data!: AgentModel;
  @Input() user: any;
  @Output() validStep: EventEmitter<boolean> = new EventEmitter<boolean>();

  NODE = environment.node;
  NODE_DO = Constants.TENANT_ID_DO;
  NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;

  dropdownEstado: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccione un estado',
    options: ['Activo', 'Inactivo'],
  };

  dropdownAgentsType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder:
      this.NODE === this.NODE_DO ? 'Split de agente' : 'Tipo de agente',
    options: [],
  };

  dropdownAgentsLevelType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo de agente',
    options: ['Broker Owner', 'Broker Manager', 'Senior', 'Junior'],
  };

  dropdownTeams: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Teams',
    options: [],
  };

  inputAutocompleteTeams: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Teams',
    isCleanButtonVisible: true,
    options: [],
  };

  dropdownDniType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo',
    options: ['Activo', 'Inactivo'],
  };

  inputWorkEmail: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un email',
  };

  inputIdAgente: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'ID Agente',
    debounceTime: 500,
  };

  errors: {
    status: boolean;
    agentId: boolean;
    agentType: boolean;
    agentLevelType: boolean;
    workEmail: boolean;
    notes: boolean;
    beginDate: boolean;
    estateDate: boolean;
    downDateQR: boolean;
    team: boolean;
    splitTeam: boolean;
    [key: string]: boolean;
  } = {
    status: false,
    agentLevelType: false,
    agentId: false,
    agentType: false,
    workEmail: false,
    notes: false,
    beginDate: false,
    estateDate: false,
    downDateQR: false,
    team: false,
    splitTeam: false,
  };

  dialogBajaQR: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '550px',
    title: 'Solicitar baja QR',
    // textButtonAction: 'Sí, dar de baja',
    // textButtonCancel: 'Cancelar',
    componentToLoad: QRDialog.DIALOG_RRHH_DISABLE_AGENT,
    value: '',
  };

  agentLevelTypes: { id: string; label: string }[] = [
    { id: 'BROKER_OWNER', label: 'Broker Owner' },
    { id: 'BROKER_MANAGER', label: 'Broker Manager' },
    { id: 'SENIOR', label: 'Senior' },
    { id: 'JUNIOR', label: 'Junior' },
  ];

  agentLevelTypeSelected: string = '';

  agentsTypes: { id: string; label: string }[] = [];
  teams: RrhhTeamsList[] = [];
  agentType = '';

  today = moment().format('YYYY-MM-DD');

  agentVerifications: {
    id: number;
    name: string;
    verificationCheckoboxId: number;
  }[] = [];

  registrationDateREMAX: QRDatePicker = {}; // Fecha de alta en RE/MAX
  startDate: QRDatePicker = {}; // Fecha de ingreso a la oficina
  deactivationDateQR: QRDatePicker = {}; // Fecha de baja QR
  deactivationDateREMAX: QRDatePicker = {}; // Fecha de baja RE/MAX

  allowAgentIdManual = false;
  errorTeamMessage = 'Seleccione un team';
  showTeamTypeChangeNotice = false;
  teamDetails: RrhhTeamDetail | undefined;
  errorTeamDetails = false;
  splitErrorMessage = '';
  isEdit = false;

  constructor(
    private readonly rrhhAgentsService: RrhhAgentService,
    private readonly rrhhVerificationsService: RrhhVerificationsService,
    private readonly getTeamsService: RrhhTeamsListService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    
    this.getAgentsType();
    if (this.user.agencyId) {
      this.getVerifications();
      this.getTeams();
    }

    if (this.NODE === this.NODE_DO) {
      this.isEdit = this.router.url.includes('edit');
      if (this.data.teamId) {
        this.getTeamDetails(this.data.teamId);
      }

      this.validateTeamRequiredDO();
    }

    this.validateFields();
    this.setDatepickersConfig();

    if (this.data.teamName) {
      this.inputAutocompleteTeams.isCleanButtonVisible = false;
      this.inputAutocompleteTeams = { ...this.inputAutocompleteTeams };
    }

    //TODO: ↓↓ HABILITADO UNOS DIAS HASTA QUE SALGA REGIONAL PARA PY
    this.allowAgentIdManual =
      this.NODE == Constants.TENANT_ID_PY || this.NODE == this.NODE_GLOBAL;
  }

  getTeamDetails(teamId: string) {
    this.getTeamsService
      .get(teamId + '/')
      .then((response: any) => {
        if (response?.data) {
          this.teamDetails = { ...response.data };
          this.errorTeamDetails = false;
          this.validateSplitsTeams();
        } else {
          this.errorTeamDetails = true;
          this.teamDetails = undefined;
        }
      })
      .catch(() => {
        this.errorTeamDetails = true;
        this.teamDetails = undefined;
      });
  }

  validateSplitsTeams() {
    this.errors.splitTeam = false;
    this.splitErrorMessage = '';

    if (
      this.NODE !== this.NODE_DO ||
      !this.teamDetails ||
      !this.data.agentType
    ) {
      return;
    }

    const SPLIT = this.getAgentTypeSplit(this.data.agentType);
    if (SPLIT === null) {
      return;
    }

    const LEADER = this.teamDetails.members.find(
      (member: TeamMember) => member.leader === true,
    );
    if (!LEADER) {
      return;
    }

    if (LEADER.id === this.data.id) {
      const MIN_SPLIT = this.teamDetails.maxMemberAgentTypeKey ?? 0;
      this.errors.splitTeam = SPLIT < MIN_SPLIT;
      if (this.errors.splitTeam) {
        this.splitErrorMessage =
          'El split del Team Leader es menor al de un miembro del equipo. Mínimo split permitido: ' +
          MIN_SPLIT +
          '%';
      }
      return;
    }

    const MAX_SPLIT = this.teamDetails.leaderAgentTypeKey ?? 0;
    this.errors.splitTeam = SPLIT > MAX_SPLIT;
    if (this.errors.splitTeam) {
      this.splitErrorMessage =
        'El split del agente supera el del Team Leader. Máximo split permitido: ' +
        MAX_SPLIT +
        '%';
    }
  }

  private getAgentTypeSplit(agentType: string): number | null {
    const MATCH = /^SPLIT_(\d+)$/.exec(agentType);
    if (!MATCH) {
      return null;
    }
    const SPLIT = Number(MATCH[1]);
    return Number.isFinite(SPLIT) && SPLIT > 0 ? SPLIT : null;
  }

  private validateTeamRequiredDO(): void {
    if (this.NODE !== this.NODE_DO) {
      return;
    }

    const IS_JUNIOR = this.data.agentLevelType === 'JUNIOR';
    this.errorTeamMessage = 'Seleccione un team';
    this.errors.team = IS_JUNIOR && !this.data.teamId;
  }

  getVerifications() {
    this.rrhhVerificationsService
      .get(this.user.agencyId)
      .then((response: any) => {
        if (response?.data?.verifications) {
          this.agentVerifications = response.data.verifications;
        }
      });
  }

  getTeams() {
    const URL = this.user.agencyId + '?page=1&pageSize=9999';
    this.getTeamsService.get(URL).then((response: any) => {
      if (response?.data?.teams) {
        this.teams = response.data.teams;
        // TODO: quitar el any
        response.data.teams.forEach((e: any) => {
          this.dropdownTeams.options.push(e.name);
          this.inputAutocompleteTeams.options.push(e.name);
        });
      }
    });
  }

  getAgentsType() {
    const ID = 'types';
    this.rrhhAgentsService.get(ID).then((response: any) => {
      if (response?.data?.agentsType) {
        const AGENTS_TYPE = (
          response.data.agentsType as { id: string; label: string }[]
        ).filter((e) => !(this.NODE === this.NODE_DO && e.id === 'SPLIT_100'));
        this.agentsTypes = AGENTS_TYPE;
        if (this.data.agentType) this.formatAgentType();
        AGENTS_TYPE.forEach((e: { id: string; label: string }) => {
          this.dropdownAgentsType.options.push(e.label);
        });
      }
    });
  }

  formatAgentType() {
    const TYPE = this.agentsTypes.find(
      (e: { id: string; label: string }) => e.id == this.data.agentType,
    );
    if (TYPE) this.agentType = TYPE.label;
  }

  changeInputIDAgente($event: InputTypes) {
    if ($event) {
      this.errors.agentId = true;
      let input2 = $event.toString();

      if (this.NODE !== this.NODE_GLOBAL) {
        const INPUT_NUMBER = Number($event);
        input2 = INPUT_NUMBER.toString();

        if (input2.length > 6 && input2.length < 10) {
          this.data.agentId = input2;
          this.errors.agentId = false;
        }
      } else {
        this.data.agentId = input2;
        this.errors.agentId = false;
      }
    } else {
      this.data.agentId = null;
      this.errors.agentId = false;
    }
    this.validateFields();
  }

  // changeAgentType($event: string) {
  //   this.errors.agentType = true;
  //   if ($event) {
  //     this.errors.team = $event == 'Team member' && !this.data.teamId;

  //     const ITEM = this.agentsTypes.find((e: any) => e.label == $event);

  //     if (ITEM?.id) {
  //       this.data.agentType = ITEM.id;
  //       this.errors.agentType = false;
  //     }
  //   }
  //   this.validateFields();
  // }

  changeAgentType($event: string) {
    this.errors.agentType = true;

    if ($event) {
      const ITEM = this.agentsTypes.find((e: any) => e.label == $event);

      if (ITEM?.id) {
        this.data.agentType = ITEM.id;
        this.errors.agentType = false;

        if (ITEM.id === 'TEAM_JUNIOR') {
          this.showTeamTypeChangeNotice = false;
          this.errorTeamMessage = 'Seleccione un team';
          this.errors.team = $event == 'Team member' && !this.data.teamId;
        } else if (this.data.teamId) {
          this.showTeamTypeChangeNotice = true;
          this.errorTeamMessage =
            'Al cambiar el tipo, el team no es editable. Usá la sección Teams.';
          this.errors.team = false;
        } else {
          this.showTeamTypeChangeNotice = false;
          this.errorTeamMessage = 'Seleccione un team';
          this.errors.team = false;
        }
      }
    }

    this.validateFields();
  }

  changeAgentTypeDO($event: string) {
    this.errors.agentType = true;
    if ($event) {
      const ITEM = this.agentsTypes.find((e: any) => e.label === $event);
      if (ITEM?.id) {
        this.data.agentType = ITEM.id;
        this.errors.agentType = false;
      }
    }
    this.validateSplitsTeams();
    this.validateFields();
  }

  changeAgentLevelTypeDO($event: string) {
    this.errors.agentLevelType = true;
    if ($event) {
      const FIND = this.agentLevelTypes.find((e) => e.label === $event);
      if (FIND) {
        this.data.agentLevelType = FIND.id;
        this.errors.agentLevelType = false;
      }
    }
    this.validateTeamRequiredDO();
    this.validateFields();
  }

  getSelectedAgentLevelLabel(): string {
    const FIND = this.agentLevelTypes.find(
      (e) => e.id === this.data.agentLevelType,
    );
    return FIND ? FIND.label : '';
  }

  changeTeam($event: string) {
    if (this.showTeamTypeChangeNotice) {
      return;
    }

    this.errors.team = true;
    if ($event) {
      const ITEM = this.teams.find((e: RrhhTeamsList) => e.name == $event);
      if (ITEM) {
        this.data.teamId = ITEM.id.toString();
        this.data.teamName = ITEM.name;
        this.errors.team = false;
      }
    }
    this.validateFields();
  }

  inputAutocompleteChange(value: string | undefined): void {
    if (this.showTeamTypeChangeNotice || this.isEdit) {
      return;
    }

    if (value) {
      const ITEM = this.teams.find((e: RrhhTeamsList) => e.name == value);
      if (ITEM) {
        this.getTeamDetails(ITEM.id.toString());
        this.data.teamId = ITEM.id.toString();
        this.data.teamName = ITEM.name;
      }
    } else {
      this.data.teamId = null;
      this.data.teamName = null;
      this.teamDetails = undefined;
      this.errors.splitTeam = false;
      this.splitErrorMessage = '';
    }

    this.validateTeamRequiredDO();
    this.validateFields();
  }

  changeStatus($event: string) {
    this.errors.status = true;
    if ($event && $event == 'Activo') {
      this.data.status = $event;
      this.errors.status = false;
    } else {
      this.onBajaQR();
      this.errors.status = false;
    }
    this.validateFields();
  }

  /*
  Se reutiliza mismo código para evento change de datepicker de Alta RE/MAX y Fecha de baja RE/MAX 
  */
  registrationDateAltaREMAXChange(e: string): void {
    this.errors.estateDate = true;
    if (e) {
      if (e <= this.today) {
        this.errors.estateDate = false;
        this.data.estateDate = e;
      }
    }
    this.validateFields();
  }

  registrationDateBajaREMAXChange(e: string): void {
    this.errors.estateDate = true;
    if (e) {
      if (e <= this.today) {
        this.errors.estateDate = false;
        this.data.downDateRMX = e;
      }
    }
    this.validateFields();
  }

  changeAltaRemax($event: any) {
    this.errors.estateDate = true;
    if ($event) {
      const DATE = $event.target.value;
      if (DATE <= this.today) {
        this.errors.estateDate = false;
        this.data.estateDate = DATE;
      }
    }
    this.validateFields();
  }

  startDateChange(e: string): void {
    this.errors.beginDate = true;
    if (e) {
      if (e <= this.today) {
        this.errors.beginDate = false;
        this.data.beginDate = e;
      }
    }
    this.validateFields();
  }

  changeBeginDate($event: any) {
    this.errors.beginDate = true;
    if ($event) {
      const DATE = $event.target.value;
      if (DATE <= this.today) {
        this.errors.beginDate = false;
        this.data.beginDate = DATE;
      }
    }
    this.validateFields();
  }

  deactivationDateQRChange(e: string) {
    this.errors.downDateQR = true;
    if (e) {
      this.errors.downDateQR = false;
      this.data.downDateQR = e;
    }
    this.validateFields();
  }

  changeInputEmail($event: InputTypes) {
    if (!$event && this.NODE === this.NODE_DO) {
      this.errors.workEmail = true;
      this.validateFields();
      return;
    }

    this.errors.workEmail = false;
    if ($event) {
      this.data.workEmail = $event.toString();
      this.errors.workEmail =
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          this.data.workEmail,
        );
    }
    this.validateFields();
  }

  changeVerifications(id: number) {
    if (this.data.agentVerifications.includes(id)) {
      const INDEX = this.data.agentVerifications.indexOf(id);
      this.data.agentVerifications.splice(INDEX, 1);
    } else {
      this.data.agentVerifications.push(id);
    }
  }

  textareaChange($event: any) {
    this.errors.notes = false;
    if ($event) {
      const INPUT = $event.target.value;
      if (INPUT.length > 1000) {
        this.errors.notes = true;
      } else {
        this.data.notes = INPUT;
        this.errors.notes = false;
      }
    }
    this.validateFields();
  }

  validateFields() {
    if (this.NODE !== this.NODE_DO) {
      this.errors.splitTeam = false;
    }

    Object.keys(this.data).forEach((key: any) => {
      if (
        key != 'workEmail' &&
        key != 'agentId' &&
        key != 'notes' &&
        key != 'downDateRMX' &&
        key != 'downDateQR'
      ) {
        if (!this.data[key] && this.errors.hasOwnProperty(key)) {
          this.errors[key] = true;
        }
      }
    });

    let result = true;
    Object.keys(this.errors).forEach((key: any) => {
      result = result && !this.errors[key];
    });

    this.validStep.emit(result);
  }

  onBajaQR() {
    const DATA_FOR_DIALOG = {
      agentDetail: this.data,
      loggedUser: this.user.loggedUser,
      onlyQR: true,
    };
    this.dialogBajaQR = {
      ...this.dialogBajaQR,
      isVisible: true,
      value: DATA_FOR_DIALOG,
    };
  }

  setDatepickersConfig(): void {
    this.registrationDateREMAX = {
      ...this.registrationDateREMAX,
      date: this.data.estateDate,
    }; // Alta RE/MAX
    this.startDate = {
      ...this.startDate,
      date: this.data.beginDate,
    }; // Fecha de ingreso a la oficina
    this.deactivationDateQR = {
      ...this.deactivationDateQR,
      date: this.data.downDateQR?.toString(),
    }; // Fecha de baja QR
    this.deactivationDateREMAX = {
      ...this.deactivationDateREMAX,
      date: this.data.downDateRMX?.toString(),
    }; // Fecha de baja RE/MAX
  }
}
